<ng-template #content let-c="close" let-d="dismiss">
  <div [class.interactive]="!isNotification && !isRoiSettingPopup && !isTermAndCondPopup && !isSpecialPopup"
      [class.informative]="isNotification && !isRoiSettingPopup && !isTermAndCondPopup && !isSpecialPopup">
    <div class="modal-header">
      <h5 *ngIf="isAlertPopup" class="modal-title">{{'common.alert' | translate}}</h5>
      <h5 *ngIf="!isAlertPopup" class="modal-title normal-popup-title">{{modelTitle}}</h5>
      <a *ngIf="shouldShowCloseIcon" class="close" data-dismiss="modal" (click)="onClose($event)" aria-label="Close">
        <img src="/assets/images/Add_Icon.svg" class="icon-close-popup">
      </a>
    </div>
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
    <div class="modal-footer justify-content-end align-items-center" *ngIf="!isNotification && !isRoiSettingPopup && !isTermAndCondPopup">
      <button *ngIf="cancelBtnLabel !== undefined" type="button" (click)="onCancel($event)" class="btn cancel-button" data-dismiss="modal">{{cancelBtnLabel}}</button>
      <button *ngIf="acceptBtnLabel !== undefined" (click)="onAccept($event)" type="button" class="btn accept-button">{{acceptBtnLabel}}</button>
    </div>
    <div class="modal-footer roi-setting-footer justify-content-end align-items-center" *ngIf="isRoiSettingPopup">
      <button *ngIf="cancelBtnLabel !== undefined" type="button" (click)="onCancel($event)" class="btn cancel-button roi-setting-button" data-dismiss="modal">{{cancelBtnLabel}}</button>
      <button *ngIf="acceptBtnLabel !== undefined" (click)="onAccept($event)" type="button" class="btn accept-button roi-setting-button">{{acceptBtnLabel}}</button>
    </div>
    <div class="modal-footer term-cond-footer justify-content-center align-items-center" *ngIf="isTermAndCondPopup">
      <button *ngIf="acceptBtnLabel !== undefined" (click)="onAccept($event)" type="button" class="btn accept-button term-cond-button">{{acceptBtnLabel}}</button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/core/achoo-popup/achoo-popup.component.html